export enum LANGUAGES {
  TH = 'th-TH',
  EN = 'en-US',
}

export enum LANGUAGES_LABEL {
  TH = 'TH',
  EN = 'EN',
}
